import { render } from "./DebitHistory.vue?vue&type=template&id=4b1fa676"
import script from "./DebitHistory.vue?vue&type=script&lang=js"
export * from "./DebitHistory.vue?vue&type=script&lang=js"

import "./DebitHistory.scss?vue&type=style&index=0&lang=scss&external"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__